import React, { Component, useState } from "react";
import CryptoJS from "crypto-js";
import { assessmentActions, questionsActions, userActions } from "../../../_actions";
import { connect } from "react-redux";
import Summary from "./Summary/Summary";
import SummaryRTL from "./SummaryRTL/Summary";

import ExpertScreen from "./Summary/ExpertScreen";
import QuestionHeader from "../Component/QuestionHeader";
import LogoAssessmentHeader from "../Component/LogoAssessmentHeader";
import LogoAssessmentSummaryHeader from "../Component/LogoAssessmentSummaryHeader";
import FeedbackModal from "./FeedbackModal";
import AssessmentReportSchool from "../Component/AssessmentReportSchool/AssessmentReportSchool";
import AssessmentReport from "../Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../Component/AssessmentSummary/AssessmentSummary";
import AssessmentTop5Summary from "../Component/AssessmentTop5Summary/AssessmentTop5Summary";
import AssessmentManagerReport from "../Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../Component/AssessmentHiringReport/AssessmentHiringReport";
import VideoFrameModal from "./Summary/VideoFrameModal/VideoFrameModal";
import VideoCourse from "./VideoCourse/VideoCourse";
import { MdArrowForwardIos } from "react-icons/md";
import moment from "moment";
import Survey from "./Survey";
import SurveyRTL from "./SurveyRTL";
import DashboardUser from "../../AdminPanel/Dashboard/DashboardUser";
import Heading from "../../AdminPanel/Component/UI/ViewButton";
import ViewButton from "../../AdminPanel/Component/UI/ViewButton";
import TriangleChart from "./Charts/TriangleChart";
import { MdOutlineStarOutline } from "react-icons/md";
import { HiOutlineBriefcase } from "react-icons/hi";
import { BsLightningCharge } from "react-icons/bs";


class QuestionPublish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      top5Talent: false,
      isDisableSubmit: false,
      SurveyCode: this.props.codeValue,
      routeMenu: "Summary",
      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textcolor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showReportModal: false,
      showSummaryReport: false,
      showManagerReportModal: false,
      showHiringReport: false,

      showViewReportThankYouButton: false,
      surveyLanguageCode: "",

      themeType: 2,
      showNameEditScreen: false,
      // nameFormData: {
      //   'name': '',
      //   'email': ''
      // },
      // errNameForm: {
      //   'name': '',
      //   'email': ''
      // },

      nameFormData: {
        name: '',
        email: '',
        gender: '', // Add gender field to your component state
        ageGroup: '' // Add ageGroup field to your component state
      },
      errNameForm: {
        name: '',
        email: '',
        gender: '', // Add gender field to your component state
        ageGroup: '' // Add ageGroup field to your component state
      },


      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      errorsCrrCodeUserDetails: {},
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      showVideoModal: '',
      showVideoResource: false,
      showMainMenu: "Summary",
      downloadStatusNo: 100,

      surveyLanguageCode: 'en',
      surveyLanguageName: 'English',
      surveyLanguageRTL: false,
    };


    this.handleShowMainSummaryModal = this.handleShowMainSummaryModal.bind(this);
    this.handleShowMainSummaryModalBack = this.handleShowMainSummaryModalBack.bind(this);
    this.handleExpertContactModalBack = this.handleExpertContactModalBack.bind(this);
    this.handleExpertContactModal = this.handleExpertContactModal.bind(this);
    this.handleInputExpertForm = this.handleInputExpertForm.bind(this);
    this.bookExpert = this.bookExpert.bind(this);
    this.handleExpertClick = this.handleExpertClick.bind(this);
    this.props.dispatch(assessmentActions.getTalentResources());


  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());
    this.props.dispatch(questionsActions.getAssessmentReport());
    this.props.dispatch(questionsActions.getAssessmenrEmployeeDetails({}));

    this.props.dispatch(questionsActions.getCoachUserSurveyList({}));


    this.props.dispatch(questionsActions.getSurveyTakenDate({}));
    this.props.dispatch(questionsActions.getAssessmentStatus({}));
    this.props.dispatch(questionsActions.getAssessmentQuestionList({}, "v4"));
    this.props.dispatch(questionsActions.getLanguageLabel());
    this.props.dispatch(questionsActions.getTranslateElementAll());
    this.props.dispatch(questionsActions.getAssessmenrEmployeeProduct({}));
  }

  decrementNumber = () => {
    this.setState((prevState) => ({
      downloadStatusNo: prevState.downloadStatusNo < 1 ? 0 : prevState.downloadStatusNo - 10,
    }));
  };



  static getDerivedStateFromProps(nextProps) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  prevQues = () => {
    this.setState({ changeType: "fade1" });
    this.setState({ ShowSubmitButton: false });
    this.setState({ submitMandatory: "" });
    let { questions } = this.props;
    let { questionsList } = questions;
    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 1 && CurrQuesIndex < questionsList.length + 1) {
        CurrQuesIndex = CurrQuesIndex - 1;

        this.setState({ CurrQuesIndex }, () => {
          // this.handleSubmitAppear();
        });
      } else {
        this.setState({
          showWelcomeScreen: false,
          showQuestionScreen: false,
          showThankyouScreen: false,
          instructionPage: true,
        });
      }
    }

    // console.log("answersList: ", answersList)
  };

  nextQues = (type2) => {
    console.log("Next Question!");
    clearTimeout(this.state.setTimeoutRef);
    clearInterval(this.state.setIntervalRef);
    window.scrollTo(0, 0);
    this.setState({ changeType: "fade", clicked: "" }, () => {
      let { questions } = this.props;
      let { questionsList, surveyScreenData, GroupQuestionOnlyList } =
        questions;
      let { CurrQuesIndex } = this.state;
      let itemQ =
        questionsList && questionsList.length > 0
          ? questionsList[CurrQuesIndex]
          : {};
      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex < questions.questionsList.length) {
          this.props.dispatch(
            questionsActions.handleRecordResTime(
              0,
              itemQ,
              AnswerListFinal,
              questionsList,
              surveyScreenData,
              GroupQuestionOnlyList
            )
          );
        }

        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------
      let isFeedback = false;
      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
          //----------------latestcode ---------------------------
          //console.log("11111111111------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};
          let flag = 0;

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }

              if (item.isMandatory) {
                let template = item.template;

                if (
                  template === 1 ||
                  template === 3 ||
                  template === 4 ||
                  template === 5 ||
                  template === 6 ||
                  template === 16 ||
                  template === 11
                ) {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                } else if (template === 13) {
                  let isAllAnswered = 0;
                  if (
                    item &&
                    item.SubQuestionList &&
                    item.SubQuestionList.length > 0
                  ) {
                    item.SubQuestionList.forEach((subQues) => {
                      let getIndex2 = AnswerListFinal.findIndex(
                        (prev) => prev.questionId === subQues.id
                      );

                      if (getIndex2 !== -1) {
                        if (
                          AnswerListFinal &&
                          AnswerListFinal[getIndex2] &&
                          AnswerListFinal[getIndex2].multiAnswer &&
                          AnswerListFinal[getIndex2].multiAnswer.length > 1
                        ) {
                          isAllAnswered++;
                        }
                      }
                    });
                  }

                  if (item.SubQuestionList.length !== isAllAnswered) {
                    flag = flag + 1;
                  }
                } else if (template === 2) {
                  if (
                    !(item && item.multiAnswer && item.multiAnswer.length > 0)
                  ) {
                    flag = flag + 1;
                  }
                } else {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                }
              }
            }
          }

          if (!flag) {
            try {
              let cryptedText = CryptoJS.AES.encrypt(
                JSON.stringify(AnswerListFinal),
                "secretkey1345100237401"
              ).toString();
              localStorage.setItem("myAnswers", JSON.stringify(cryptedText));
            } catch (error) {
              console.log("not saved!");
            }

            //console.log("isFeedback----------->", isFeedback);

            if (isFeedback && type2 !== 2) {
              this.setState({ showFeedbackModal: true });
            } else {
              CurrQuesIndex = CurrQuesIndex + 1;

              this.setState({ CurrQuesIndex }, () => {
                this.setState({
                  ShowNotAttempted: false,
                  showFeedbackModal: false,
                });

                this.handleSubmitAppear();
              });
            }
          } else {
            this.setState({ ShowNotAttempted: true });
          }

          // console.log("CurrQuesIndex------>", CurrQuesIndex);
          // console.log("questionsList.length------>", questionsList.length);
          // console.log("itemQ------>", itemQ);

          if (itemQ && itemQ.seconds && !this.state.disableTimer) {
            if (CurrQuesIndex < questionsList.length) {
              let setTimeoutRef = setTimeout(
                () => this.nextQues(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            } else {
              let setTimeoutRef = setTimeout(
                () => this.saveAnswers(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            }
          }
        } else if (CurrQuesIndex === questionsList.length) {
          //console.log("222222222------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }
            }
          }

          if (isFeedback && type2 !== 2) {
            this.setState({ showFeedbackModal: true });
          }
        }
      }
    });
  };

  submitFeedback = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex === questionsList.length) {
        this.setState({ showFeedbackModal: false }, () => {
          this.handleSubmitAppear();
        });
      } else {
        CurrQuesIndex = CurrQuesIndex + 1;
        this.setState({ CurrQuesIndex }, () => {
          this.setState({ ShowNotAttempted: false, showFeedbackModal: false });
          this.handleSubmitAppear();
        });
      }
    }
  };

  closeFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  handleSubmitAppear = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;
    setTimeout(() => {
      if (
        questionsList &&
        questionsList.length > 0 &&
        questionsList.length === CurrQuesIndex
      ) {
        this.setState({ ShowSubmitButton: true });
      } else {
        this.setState({ ShowSubmitButton: false });
      }
    }, 300);
  };

  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
      langList
    } = questions;

    let { CurrQuesIndex } = this.state;

    if (this.state.radioButton === currentOption.id) {
      this.setState({ radioButton: null });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          "",
          0,
          surveyScreenData,
          "",
          GroupQuestionOnlyList,
          langList
        )
      );
    } else {
      // console.log("currentOption----------------------IIIIIIIIIIIIIIIIIIIIIIIII--------------------->",currentOption)
      this.setState({ radioButton: currentOption.id });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          Index,
          GroupQuestionOnlyList,
          langList
        )
      );
    }

    this.setState({ radioButton: null });

    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    // setTimeout(()=>this.checkFeedback(), 300);

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    setTimeout(() => this.nextQues(), 300);
  };

  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    if (true) {
      this.setState({ radioButton: currentOption.id });
      // console.log("currentOption::", currentOption)
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    }
    // setTimeout(()=>this.nextQues(), 300);
  };

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData.isInstruction) {
      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: true,
        showNameEditScreen: false
      });
    } else {
      let { questionsList } = questions;
      let itemQ =
        questionsList && questionsList.length > 0 ? questionsList[0] : {};
      //console.log("itemQ--01-->", itemQ);

      if (itemQ && itemQ.seconds && !this.state.disableTimer) {
        //console.log("Seconds--->", itemQ.seconds * 1000);
        let setTimeoutRef = setTimeout(
          () => this.nextQues(),
          itemQ.seconds * 1000
        );
        this.setState(
          {
            timeCounter: itemQ.seconds,
            setTimeoutRef: setTimeoutRef,
            setTimeoutInit: moment().unix(),
          },
          () => {
            let setIntervalRef = setInterval(
              () =>
                this.setState({
                  timeCounter:
                    this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
                }),
              1000
            );
            this.setState({ setIntervalRef: setIntervalRef });
          }
        );
      }

      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: true,
        showThankyouScreen: false,
        instructionPage: false,
        showNameEditScreen: false
      });
    }
    window.scrollTo(0, 0);
  };

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    let itemQ =
      questionsList && questionsList.length > 0 ? questionsList[0] : {};
    //console.log("itemQ--02-->", itemQ);

    if (itemQ && itemQ.seconds && !this.state.disableTimer) {
      //console.log("Seconds--->", itemQ.seconds * 1000);
      let setTimeoutRef = setTimeout(
        () => this.nextQues(),
        itemQ.seconds * 1000
      );
      this.setState(
        {
          timeCounter: itemQ.seconds,
          setTimeoutRef: setTimeoutRef,
          setTimeoutInit: moment().unix(),
        },
        () => {
          let setIntervalRef = setInterval(
            () =>
              this.setState({
                timeCounter:
                  this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
              }),
            1000
          );
          this.setState({ setIntervalRef: setIntervalRef });
        }
      );
    }

    this.setState({
      showWelcomeScreen: false,
      showQuestionScreen: true,
      showThankyouScreen: false,
      instructionPage: false,
    });
    window.scrollTo(0, 0);
  };

  saveAnswers() {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData) {
      this.setState({
        afterSubmitData: surveyScreenData,
      });
    }

    let survey = null;

    //---------------------- new code ------------------------------------------

    let { questionsList } = questions;

    //---------------------------- basic ---------------------------------------
    let answersList = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];

    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }
    //-------------------------------------------------------------------

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      let flag = 0;
      // console.log(" CurrQuesIndex=====>: ",CurrQuesIndex," questionsList.length=====>: ", questionsList.length)

      if (CurrQuesIndex > 0 && CurrQuesIndex <= questionsList.length) {
        //----------------latestcode ---------------------------

        let questionId =
          questionsList &&
            questionsList[CurrQuesIndex - 1] &&
            questionsList[CurrQuesIndex - 1].id
            ? questionsList[CurrQuesIndex - 1].id
            : "";

        if (answersList && answersList.length > 0) {
          let getIndex2 = answersList.findIndex(
            (prev) => prev.questionId === questionId
          );
          if (getIndex2 !== -1) {
            let item = answersList[getIndex2];

            if (item.isMandatory) {
              let template = item.template;

              if (
                template === 1 ||
                template === 3 ||
                template === 4 ||
                template === 5 ||
                template === 6 ||
                template === 16 ||
                template === 11
              ) {
                if (!item.answer) {
                  flag = flag + 1;
                }
                // console.log(" template: ",template," answer: ",item.answer," flag: ",flag)
              } else if (template === 13) {
                let isAllAnswered = 0;
                if (
                  item &&
                  item.SubQuestionList &&
                  item.SubQuestionList.length > 0
                ) {
                  item.SubQuestionList.forEach((subQues) => {
                    let getIndex2 = AnswerListFinal.findIndex(
                      (prev) => prev.questionId === subQues.id
                    );

                    if (getIndex2 !== -1) {
                      if (
                        AnswerListFinal &&
                        AnswerListFinal[getIndex2] &&
                        AnswerListFinal[getIndex2].multiAnswer &&
                        AnswerListFinal[getIndex2].multiAnswer.length > 1
                      ) {
                        isAllAnswered++;
                      }
                    }
                  });
                }

                if (item.SubQuestionList.length !== isAllAnswered) {
                  flag = flag + 1;
                }
              } else if (template === 2) {
                if (
                  !(item && item.multiAnswer && item.multiAnswer.length > 0)
                ) {
                  flag = flag + 1;
                }
              } else {
                if (!item.answer) {
                  flag = flag + 1;
                }
              }
            }
          }
        }

      }

      if (!flag) {
        if (!this.state.isDisableSubmit) {
          clearTimeout(this.state.setTimeoutRef);
          clearInterval(this.state.setIntervalRef);

          console.log("Answer Submitted!");



          setTimeout(() => {
            this.setState({ showViewReportThankYouButton: true });
            this.interval = setInterval(this.decrementNumber, 500);
            setTimeout(() => {
              this.sendPDFMail(this.state.surveyLanguageCode)
              window.location.reload();
            }, 5000);
          }, 3000);

          this.props.dispatch(
            questionsActions.saveAssessmentAnswers(
              AnswerListFinal,
              survey,
              this.props,
              this.state.IpObj,
              true
            )
          );
        }
        this.setState({ submitMandatory: "" });
      } else {
        this.setState({
          submitMandatory: "Please attempt mandatory question!",
        });
      }
    }

  }

  ansTextBoxClick(ques) {
    this.setState({ currQues: ques });
  }

  ansTextBoxChange1 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 1,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  handleFeedbackInput = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      name: e.target.value,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitFeedbackChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  ansNPSInput = (val, ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: val,
      ans: 1,
    };

    this.setState({ textAnswer: val });

    let { CurrQuesIndex } = this.state;

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
      console.log(
        "resTime----------------------resTime--------------------->",
        resTime
      );
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // console.log("-----questionsListlength---->", questionsList.length);
    // console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    // if(!Ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    setTimeout(() => this.nextQues(), 300);
  };

  ansTextBoxChange2 = (e, Ques) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: e.target.value,
      ans: 2,
    };

    this.setState({ textAnswer: e.target.value });

    // console.log("ansData; ", ansData)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );
  };

  clickOK = () => {
    // setTimeout(()=>this.nextQues(), 300);
    this.nextQues();
  };

  clickOKLast = (Ques) => {
    // console.log("clickOKLast; ")

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let ansData = {
      _id: "",
      name: "",
      ans: 3,
    };

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        Ques,
        answersList,
        questionsList,
        ansData,
        null,
        surveyScreenData,
        "",
        GroupQuestionOnlyList
      )
    );

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
        CurrQuesIndex = CurrQuesIndex + 1;

        this.setState({ CurrQuesIndex });
      }
    }

    let answersList2 = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];
    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }

    let flag = 0;
    let unattemptList = [];
    answersList2.forEach((item, index) => {
      if (item.isMandatory) {
        let template = item.template;

        if (
          template === 1 ||
          template === 3 ||
          template === 4 ||
          template === 5 ||
          template === 6 ||
          template === 16 ||
          template === 11
        ) {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else if (template === 13) {
          let isAllAnswered = 0;
          if (item && item.SubQuestionList && item.SubQuestionList.length > 0) {
            item.SubQuestionList.forEach((subQues) => {
              let getIndex2 = AnswerListFinal.findIndex(
                (prev) => prev.questionId === subQues.id
              );
              if (
                AnswerListFinal &&
                AnswerListFinal[getIndex2] &&
                AnswerListFinal[getIndex2].multiAnswer &&
                AnswerListFinal[getIndex2].multiAnswer.length > 1
              ) {
                isAllAnswered++;
              }
            });
            if (item.SubQuestionList.length !== isAllAnswered) {
              flag = flag + 1;
              unattemptList.push(index + 1);
            }
          }
        } else if (template === 2) {
          if (!(item && item.multiAnswer && item.multiAnswer.length > 0)) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        } else {
          if (!item.answer) {
            flag = flag + 1;
            unattemptList.push(index + 1);
          }
        }
      }
    });


    if (flag) {
      this.setState({ unattemptList: unattemptList });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        if (this.state.unattemptList && this.state.unattemptList.length > 0) {
          // console.log("-----working x")
          this.setState({ CurrQuesIndex: unattemptList[0] });
          // console.log("-----working x 1")
        }
      }
    } else {
      this.setState({ unattemptList: [] });

      if (this.state.mandatoryOn && questionsList && questionsList.length > 0) {
        // console.log("All mandatory questions are attempted , now go to last question i.e. submit! ")
        this.setState({ CurrQuesIndex: questionsList.length });
      }
    }

    //nothing
  };

  onMandatoryAttempt = (elem) => {
    this.setState({ CurrQuesIndex: elem });
    this.setState({ mandatoryOn: true });
  };

  gotoSubmit = () => {
    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      this.setState({ CurrQuesIndex: questionsList.length });
    }
  };

  // handleLanguage = (e) => {
  //   if (e.target.value === "en") {
  //     this.setState({ surveyLanguageCode: "", surveyLanguageName: "" });
  //   } else {
  //     this.setState({
  //       surveyLanguageCode: e.target.value,
  //       surveyLanguageName: "",
  //     });
  //   }
  // };

  openDropdownQuestion = (check) => {
    this.setState({ showDropdownQues: check });
  };

  handleDropdownSelect = (value) => {
    this.setState({ dropdownInput: value, showDropdownQues: false });
  };

  handleMatrixRadio = (ques, subQues, currentOption) => {
    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;


    //console.log('------>answersList------>',answersList)

    this.props.dispatch(
      questionsActions.handleSubmitPreChange(
        ques,
        answersList,
        questionsList,
        currentOption,
        currentOption.weightage,
        surveyScreenData,
        subQues,
        GroupQuestionOnlyList
      )
    );

    // setTimeout(()=>this.nextQues(), 300);
  };

  handleReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showReportModal: true });
  };

  handleSummaryReport = (_, type) => {
    this.props.dispatch(questionsActions.getAssessmentReport({
      "type": type
    }));
    // this.setState({ showSummaryReport: true });
  };
  goToSummary = () => {
    window.location.reload();
  }

  viewReport = (type) => {
    let { questions, temp } = this.props;
    let { getAssessmenrEmployeeProductData } = questions;
    let ele = getAssessmenrEmployeeProductData;
    console.log("ele 1-->", ele);
    if (ele && ele.productId && ele.productId.code) {
      let code = ele.productId.code;
      this.handleSummaryReport(ele, type);

      if (code === "Top5TalentplusStrengths") {
        console.log("Top5TalentplusStrengths 1-->");

        this.setState({
          showReportModal: false,
          showSummaryReport: true,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });

      } else if (code === "TalentPlusStrengths21") {
        console.log("TalentPlusStrengths21 1-->");
        // this.handleReport(ele);


        this.setState({
          showReportModal: true,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });
      } else if (code === "TalentplusManagerStrengths") {
        console.log("TalentplusManagerStrengths 1-->");
        // this.handleManagerReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: true,
          showHiringReportModal: false,
          showSchoolReportModal: false
        });
      } else if (code === "TalentPlusHiringStrengths") {
        console.log("TalentPlusHiringStrengths 1-->");
        // this.handleHiringReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: true,
          showSchoolReportModal: false
        });
      } else if (code === "Top5TeenTalentplusStrengths") {
        // this.handleSchoolReport(ele);


        this.setState({
          showReportModal: false,
          showSummaryReport: false,
          showManagerReportModal: false,
          showHiringReportModal: false,
          showSchoolReportModal: true
        });
      }

    };


    this.setState({ crrEmpDetails: temp });
  };


  handleHiringReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showHiringReportModal: true });
  };

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };

  closeManagerReportModal = () => {
    this.setState({ showManagerReportModal: false });
  };

  closeHiringReportModal = () => {
    this.setState({ showHiringReportModal: false });
  };

  handleLanguage = (item) => {
    console.log("item------------------->", item);
    if (item.shortName === "en") {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: "English",
        surveyLanguageRTL: false,
      });
    } else {
      this.setState({
        surveyLanguageCode: item.shortName,
        surveyLanguageName: item.name,
        surveyLanguageRTL: item.isRTL,
      });
    }
  };

  handleDownloadStatus = () => {
    let data = {
      moduleType: "ASSESSMENT",
    };
    this.props.dispatch(assessmentActions.assessmentDownloadStatus(data));
  };




  goToUpdateDetailsPage = () => {

    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;
    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name && getAssessmenrEmployeeDetailsData.email) {
      this.goToInstructionPage()
    } else {
      let { nameFormData } = this.state;
      nameFormData["name"] = getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name ? getAssessmenrEmployeeDetailsData.name : "";
      if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name) {
        nameFormData["email"] = getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.email ? getAssessmenrEmployeeDetailsData.email : "";
      }
      this.setState({
        nameFormData,
        showNameEditScreen: true
      })
    }

    window.scrollTo(0, 0);
  };

  handleNameInput = (e) => {
    let { nameFormData } = this.state;
    nameFormData[e.target.name] = e.target.value;
    this.setState({ nameFormData })
  }

  // onUpdateDetails = () => {
  //   let { nameFormData, errNameForm } = this.state;

  //   if (nameFormData.name && nameFormData.email) {
  //     let data = {
  //       name: nameFormData.name,
  //       email: nameFormData.email
  //     };
  //     this.props.dispatch(questionsActions.updateAssessmentUserDetails(data));

  //     this.goToInstructionPage()

  //     this.setState({
  //       errNameForm: {
  //         'name': '', 'email': ''
  //       },
  //       nameFormData: {
  //         'name': '', 'email': ''
  //       }
  //     })
  //   } else {
  //     if (!nameFormData.name) {
  //       errNameForm["name"] = 'Please enter your name';
  //     }
  //     if (!nameFormData.email) {
  //       errNameForm["email"] = 'Please enter your email';
  //     } else {
  //       function validateEmail(email) {
  //         const re =
  //           /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //         return re.test(String(email).toLowerCase());
  //       }
  //       if (!validateEmail(nameFormData["email"])) {
  //         errNameForm["email"] = 'Please enter valid email';
  //       }

  //     }
  //     this.setState({ errNameForm })
  //   }

  // }

  onUpdateDetails = () => {
    let { nameFormData, errNameForm } = this.state;
    let { questions } = this.props;
    let { getAssessmentStatusData } = questions;
    let isSchool = getAssessmentStatusData && getAssessmentStatusData.isSchool ? true : false;


    if (!nameFormData.name) {
      errNameForm["name"] = 'Please enter your name';
    } else {
      errNameForm["name"] = "";
    }


    if (!nameFormData.email) {
      errNameForm["email"] = 'Please enter your email';
    } else {
      const emailPattern =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValid = emailPattern.test(nameFormData["email"]);

      // let validE = validateEmail(nameFormData["email"]);
      console.log("isValid---------------------->", isValid)

      if (!isValid) {
        errNameForm["email"] = 'Please enter valid email';
      } else {
        errNameForm["email"] = "";
      }
    }

    if (isSchool) {
      if (!nameFormData.gender) {
        errNameForm["gender"] = 'Please select your gender';
      } else {
        errNameForm["gender"] = '';
      }

      if (!nameFormData.ageGroup) {
        errNameForm["ageGroup"] = 'Please select your Age Group';
      } else {
        errNameForm["ageGroup"] = '';
      }
    }


    this.setState({ errNameForm }, () => {

      console.log("errNameForm---->", errNameForm)
      if ((isSchool ? (errNameForm["gender"] === "" && errNameForm["ageGroup"] === "") : true) && (errNameForm["name"] === "" && errNameForm["email"] === "")) {

        let data = {
          name: nameFormData.name,
          email: nameFormData.email
        };

        if (isSchool) {
          data["gender"] = nameFormData.gender;
          data["ageGroup"] = nameFormData.ageGroup;
        }
        this.props.dispatch(questionsActions.updateAssessmentUserDetails(data));
        this.goToInstructionPage()
        this.setState({
          errNameForm: {
            'name': '', 'email': '', 'gender': '', 'ageGroup': '' // Reset error for gender field
          },
          nameFormData: {
            'name': '', 'email': '', 'gender': '', 'ageGroup': '' // Reset form for gender field
          }
        })


      }
    })

  }

  handleGenderChange = (e) => {
    const { nameFormData } = this.state;
    const selectedGender = e.target.value;

    this.setState({
      nameFormData: {
        ...nameFormData,
        gender: selectedGender
      }
    });
  }

  handleAgeGroupChange = (e) => {
    const { nameFormData } = this.state;
    const selectedAgeGroup = e.target.value;

    this.setState({
      nameFormData: {
        ...nameFormData,
        ageGroup: selectedAgeGroup
      }
    });
  }


  loadExpertData = () => {
    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;

    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.id) {
      let eleUser = getAssessmenrEmployeeDetailsData;
      let temp2 = {
        employeeId: eleUser && eleUser.id ? eleUser.id : "",
        name: eleUser && eleUser.name ? eleUser.name : "",
        email: eleUser && eleUser.email ? eleUser.email : "",
        mobile: eleUser && eleUser.mobile ? eleUser.mobile : ""
      };
      this.setState({ crrCodeUserDetails: temp2 });
    }

    this.props.dispatch(assessmentActions.getExpertDetailsList());
    this.props.dispatch(assessmentActions.getExpertOrderBookList());
  }



  handleShowMainSummaryModalBack() {

    this.setState({ showMainSummaryModal: true, showMyExpertList: false, backSummary: false, top5Talent: false });
  }

  handleShowMainSummaryModal(ele) {

    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());

    this.setState({ showMainSummaryModal: false, backSummary: true, showMyExpertList: false, crrDetail: ele, top5Talent: true });
  }

  handleExpertContactModal(ele) {
    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: ele, topFiveTalent: false
    });
  }

  handleExpertContactModalBack() {
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({
      contactExpertSection: false, topFiveTalent: true
    });
  }
  handleInputExpertForm(value, name) {
    let { crrCodeUserDetails, errorsCrrCodeUserDetails } = this.state;
    crrCodeUserDetails[name] = value;
    errorsCrrCodeUserDetails[name] = "";
    this.setState({ crrCodeUserDetails, errorsCrrCodeUserDetails });
  }

  // inputChangeUpdateUser = (e) => {
  //   e.preventDefault();
  //   let { name, value } = e.target;
  //   let fieldsUserUpdate = this.state.fieldsUserUpdate;
  //   let errorsUpdateQuote = this.state.errorsUpdateQuote;
  //   fieldsUserUpdate[name] = value;
  //   errorsUpdateQuote[name] = "";
  //   console.log(name, value);
  //   this.setState({ fieldsUserUpdate, errorsUpdateQuote });
  // }

  bookExpert(userDetails, expertDetails) {

    if (this.handleValidationUpdateUser()) {
      let data = {
        "name": userDetails.name,
        "email": userDetails.email,
        "mobile": userDetails.mobile,
        "message": userDetails.message,
        "expertId": expertDetails.id,
      }
      console.log("--------->data<---------123123123131-------", data)

      this.props.dispatch(assessmentActions.userAssessmentExpertOrderPlace(data));

    }

  }

  handleValidationUpdateUser = () => {
    let crrCodeUserDetails = this.state.crrCodeUserDetails;
    let errorsCrrCodeUserDetails = {};
    let formIsValid = true;

    //name
    if (!crrCodeUserDetails["name"] || crrCodeUserDetails["name"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["name"] = "Name cannot be empty";
    }

    //email
    if (!crrCodeUserDetails["email"] || crrCodeUserDetails["email"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["email"] = "Email cannot be empty";
    }
    //mobile
    if (!crrCodeUserDetails["mobile"] || crrCodeUserDetails["mobile"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["mobile"] = "Mobile cannot be empty";
    }
    //message
    if (!crrCodeUserDetails["message"] || crrCodeUserDetails["message"] === "") {
      formIsValid = false;
      errorsCrrCodeUserDetails["message"] = "Message cannot be empty";
    }
    console.log("errorsCrrCodeUserDetailserrorsCrrCodeUserDetails:::::", errorsCrrCodeUserDetails);
    this.setState({ errorsCrrCodeUserDetails: errorsCrrCodeUserDetails });
    return formIsValid;
  }

  handleExpertClick() {
    const { history } = this.props;
    history.push('/assessment/expert'); // Replace '/expert-page' with the actual route of your expert page
  }

  viewMyExpert = () => {
    this.loadExpertData()
    this.props.dispatch(assessmentActions.userAssessmentExpertOrderEmpty());
    this.setState({ backSummary: true, showMyExpertList: true })

  }

  handlePlayVideo = (dimension) => {
    console.log("dimension:::::", dimension);
    this.setState({ showVideoModal: dimension });
  }

  closeVideoModal = () => {
    this.setState({ showVideoModal: '' });
  }

  viewMyVideoReport = () => {
    this.setState({ showVideoResource: true })
  }

  closeVideoCourse = () => {
    this.setState({ showVideoResource: false })
  }

  handleMainMenu = (value) => {
    this.setState({ showMainMenu: value }, () => {
      if (value === "Summary") {
        this.setState({ backSummary: false, top5Talent: false })
      } else if (value === "VideoTutorials") {
        this.viewMyVideoReport();
      } else if (value === "Report") {
        this.viewReport();
      } else if (value === "Top5Summary") {
        this.viewReport("Top5Summary");
      } else if (value === "Experts") {
        this.viewMyExpert();
      }
    });
  }

  // handleMainMenu = (newRouteMenu) => {
  //   this.setState({ routeMenu: newRouteMenu }, () => {
  //     if (newRouteMenu === "Summary") {
  //       // Your logic for Summary
  //     } else if (newRouteMenu === "VideoTutorials") {
  //       // Your logic for VideoTutorials
  //     } else if (newRouteMenu === "Report") {
  //       // Your logic for Report
  //     } else if (newRouteMenu === "Experts") {
  //       // Your logic for Experts
  //     }
  //   });
  // }


  downloadRTLReport = (value, lang) => {
    this.props.dispatch(assessmentActions.getUserAssessmentLangReport({
      shortName: value
    }, lang));

  }

  sendPDFMail = (value) => {
    this.props.dispatch(assessmentActions.getAssessmentReportMail({ shortName: value, isTest: true }));
  }

  getBadgeStyle = (status) => {
    switch (status) {
      case 'Completed':
        return 'bg-emerald-50 text-emerald-500 border-emerald-100';
      case 'In-Progress':
        return 'bg-amber-50 text-amber-500 border-amber-100';
      case 'Not started':
      default:
        return 'bg-blue-50 textcolor border-purple-100';
    }
  };

  render() {
    const { routeMenu } = this.state;
    let { questions, assessment, onLogout, handleTestPayment,
      onAssessmentSummary, switchToAdmin, openAIBot,
      getCoachUserSurveyListData
    } = this.props;
    let {
      userAssessmentExpertOrderPlaceData,
      getExpertOrderBookListData,
      getTalentResourcesData
    } = assessment;

    let {
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getAssessmenrEmployeeDetailsData,
      questionsList,
      answersList,
      surveyStatus,
      GroupQuestionOnlyList,
      getTranslateElementAllData,
      loading,
      getSurveyTakenDateData
    } = questions;

    let check =
      getAssessmentStatusData && getAssessmentStatusData.check
        ? getAssessmentStatusData.check
        : 0;
    let isSchool =
      getAssessmentStatusData && getAssessmentStatusData.isSchool
        ? true
        : false;

    let createdAt =
      getSurveyTakenDateData && getSurveyTakenDateData.createdAt
        ? moment(parseInt(getSurveyTakenDateData.createdAt))
          .utcOffset("+05:30")
          .format("DD MMMM, YYYY")
        : "";


    let {
      timeCounter,
      showFeedbackModal,
      CurrQuesIndex,
      afterSubmitData,
      clicked,
      ShowNotAttempted,
      submitMandatory,
      showViewReportThankYouButton,
      showSummaryReport,
      showManagerReportModal,
      showHiringReportModal,
      themeType,
      showNameEditScreen,
      nameFormData,
      errNameForm,
      showMyExpertList,
      showVideoModal,
      showVideoResource,
      showMainMenu,
      showSchoolReportModal,
      downloadStatusNo,
      surveyLanguageRTL
    } = this.state;


    console.log("isSchool-11111-->", isSchool)
    // console.log('showMainMenushowMainMenushowMainMenushowMainMenushowMainMenu', showMainMenu);

    let { UserRespondantName } = this.props;

    let { showReportModal, surveyLanguageCode, surveyLanguageName } =
      this.state;

    const isMobile = window.innerWidth <= 700;

    let surveyScreenData = {};
    if (questions.surveyScreenData) {
      surveyScreenData = { ...questions.surveyScreenData };

    }

    let bgImage = "";
    let bgColor = "";
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;
    }

    let welcomeTextDislay = [];
    let instructionTextDislay = [];

    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText;
    }

    let surveytitle = "";
    let bgType = "";

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }

    let LabelObj = questions.getLanguageLabelData;
    let LanguageList = questions.langList;


    function showRadioMatrix(SubQues, option) {
      let getIndex1 = answersList.findIndex(
        (prev) => prev.questionId === SubQues.id
      );
      let getIndex4 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionHead === option.heading
      );
      let getIndex3 = answersList[getIndex1]["multiAnswer"].findIndex(
        (prev) => prev.optionId === option.id
      );

      if (getIndex4 !== -1) {
        if (getIndex3 !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function FormatMatriXOptionHeading(question, isOption) {
      let paraObjShow = {};
      if (question && question.optionsList && question.optionsList.length > 0) {
        question.optionsList.forEach((item) => {
          if (paraObjShow && paraObjShow[item.heading]) {
            paraObjShow[item.heading] += 1;
          } else {
            paraObjShow[item.heading] = 1;
          }
        });
      }

      let headingList = [];
      let tempKey = Object.keys(paraObjShow);
      if (tempKey && tempKey.length > 0) {
        tempKey.forEach((item) => {
          headingList.push({
            name: item,
            span: paraObjShow[item],
          });
        });
      }

      if (isOption) {
        let OptionList = [];
        if (headingList && headingList.length > 0) {
          headingList.forEach((heading) => {
            if (
              question &&
              question.optionsList &&
              question.optionsList.length > 0
            ) {
              question.optionsList.forEach((option) => {
                if (heading.name === option.heading) {
                  OptionList.push(option);
                }
              });
            }
          });
        }
        return OptionList;
      } else {
        return headingList;
      }
    }

    function TranslateQuestion(surveyLanguageCode, question) {
      return surveyLanguageCode !== ""
        ? question &&
          question.transl &&
          question.transl[surveyLanguageCode] &&
          question.transl[surveyLanguageCode].name
          ? question.transl[surveyLanguageCode].name
          : question.name
        : question.name;
    }

    function TranslationOptionMatrix(
      question,
      heading,
      surveyLanguageCode,
      type
    ) {
      let optionId = "";
      if (question && question.optionsList && question.optionsList.length > 0) {
        let Index = question.optionsList.findIndex(
          (prev) => prev.heading === heading
        );
        optionId = question.optionsList[Index].id;
      }
      let text =
        surveyLanguageCode !== ""
          ? question &&
            question.transl &&
            question.transl[surveyLanguageCode] &&
            question.transl[surveyLanguageCode].headingList &&
            question.transl[surveyLanguageCode].headingList[optionId]
            ? question.transl[surveyLanguageCode].headingList[optionId]
            : heading
          : heading;

      let arr = text.split("-");
      if (type === 1) {
        return arr && arr[0] ? arr[0] : text;
      }
      if (type === 2) {
        return arr && arr[0] ? arr[0] : text;
      } else if (type === 3) {
        return arr && arr[1] ? arr[1] : "";
      } else {
        return text;
      }
    }


    let { getSurveyTemplateByCodeData } = this.props;
    function SurveyAttributes(name) {
      return surveyLanguageCode !== ""
        ? getSurveyTemplateByCodeData &&
          getSurveyTemplateByCodeData.transl &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode] &&
          getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          ? getSurveyTemplateByCodeData.transl[surveyLanguageCode][name]
          : ""
        : getSurveyTemplateByCodeData && getSurveyTemplateByCodeData[name]
          ? getSurveyTemplateByCodeData[name]
          : "";
    }


    function MandatoryMsg(Ques) {
      let Text = "";
      let Color = "";
      if (Ques.isMandatory) {
        if (Ques.templateId === 13) {
          Text = SurveyAttributes("allmandatoryText")
            ? SurveyAttributes("allmandatoryText") + "*"
            : "All questions are mandatory*";
          Color = "#eb3434";
        } else {
          Text = "*";
          Color = "#eb3434";
        }
      }
      return {
        text: Text,
        color: Color,
      };
    }

    function showNotCompletedFn(Que) {
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];
      let check = false;
      if (ShowNotAttempted) {
        let getIndex = AnswerListFinal.findIndex(
          (prev) => prev.questionId === Que.id
        );
        if (getIndex !== -1) {
          check =
            AnswerListFinal[getIndex].multiAnswer.length !== 2 ? true : false;
        }
      }

      // console.log("showNotCompletedFn===>",check)
      return check;
    }

    function CompletedCountV1(list) {
      let list2 = [];
      if (list && list.length > 0) {
        list2 = list.filter((prev) => prev.answer !== "");
      }
      // console.log("list2::::", list2);
      if (list2 && list2.length > 0) {
        return list2.length;
      } else {
        return 0;
      }
    }

    let answerCount = CompletedCountV1(answersList);

    let completedMilestone = answerCount;

    function getGroupIndex(QuesId) {
      //console.log("QuesId---------->",QuesId)

      if (GroupQuestionOnlyList && GroupQuestionOnlyList.length > 0) {
        let getIndex = GroupQuestionOnlyList.findIndex(
          (prev) => prev.id === QuesId
        );
        if (getIndex !== -1) {
          //console.log("match---------->",getIndex+1)

          return (getIndex + 1).toString() + ". ";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }

    function functionNameVariable(quesName) {
      return quesName && quesName.toString()
        ? quesName.toString().replace("[variable]", UserRespondantName)
        : quesName;
    }


    function getSecondsToTime(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours())) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds());
      return format;
    }

    function getSecondsToTimeReverse(given_seconds) {
      var seconds = parseInt(given_seconds);
      var format =
        (moment.duration(seconds, "seconds").seconds() < 10
          ? "0" + moment.duration(seconds, "seconds").seconds()
          : moment.duration(seconds, "seconds").seconds()) +
        ":" +
        (moment.duration(seconds, "seconds").minutes() < 10
          ? "0" + moment.duration(seconds, "seconds").minutes()
          : moment.duration(seconds, "seconds").minutes()) +
        ":" +
        (Math.floor(moment.duration(seconds, "seconds").asHours()) < 10
          ? Math.floor(moment.duration(seconds, "seconds").asHours())
          : Math.floor(moment.duration(seconds, "seconds").asHours()));
      return format;
    }
    // console.log("surveyLanguageCode------------>", surveyLanguageCode);

    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (
          getTranslateElementAllData &&
          getTranslateElementAllData.length > 0
        ) {
          let getIndex = getTranslateElementAllData.findIndex(
            (prev) => prev.name === name
          );
          if (getIndex !== -1) {
            sentence =
              getTranslateElementAllData &&
                getTranslateElementAllData[getIndex] &&
                getTranslateElementAllData[getIndex]["transl"] &&
                getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode]
                ? getTranslateElementAllData[getIndex]["transl"][
                surveyLanguageCode
                ]
                : "";
          }
        }
        console.log("sentence------------>", sentence);
        console.log("surveyLanguageCode------------>", surveyLanguageCode);
        console.log(
          "getTranslateElementAllData------------>",
          getTranslateElementAllData
        );

        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence =
          element &&
            element["details"] &&
            element["details"]["transl"] &&
            element["details"]["transl"][surveyLanguageCode] &&
            element["details"]["transl"][surveyLanguageCode][name]
            ? element["details"]["transl"][surveyLanguageCode][name]
            : "";
        return sentence ? sentence : text;
      } else {
        return text;
      }
    };

    function EditButtonFn(name, text) {
      return <>{GetTextByLanguage(name, text)}</>;
    }
    function EditDetailsFn(element, name, text, type) {
      if (type === 1) {
        console.log("element-----111--------->", element)
        console.log("name--------111------>", name)
        console.log("text-------111------->", text)
      }
      return <>{GetDetailsByLanguage(element, name, text)}</>;
    }

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getTheme(field, init) {
      if (themeType === 2) {
        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")';
        } else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')";
        } else if (field === "text") {
          return "#3D405B";
        } else if (field === "lightblue") {
          return hexToRgbA("#2196F3", "0.12");
        } else if (field === "textblue") {
          return "#2196F3";
        } else if (field === "lightblue") {
          return hexToRgbA("#2196F3", "0.12");
        } else if (field === "hoverActive") {
          return (
            "hover:bg-[" +
            hexToRgbA("#2196F3", "0.12") +
            "] hover:border-[#2196F3] hover:text-[#2196F3] "
          );
        } else if (field === "grayheader") {
          return " bg-[" + hexToRgbA("#3D405B", "0.05") + "] ";
        } else if (field === "textOption") {
          return "border-[#3D405B] text-[#3D405B] ";
        } else {
          return init;
        }
      } else {
        return init;
      }
    }


    let crrEmpDetails = getAssessmenrEmployeeDetailsData;

    let { showWelcomeScreen, instructionPage, showQuestionScreen,
      submitSucces, unattemptList, showRedFlag, ShowSubmitButton,
      showThankyouScreen, alreadySubmitted
    } = this.state;


    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }
    const assessments =
      Array.isArray(getAssessmentReportByEmpIDData) && getAssessmentReportByEmpIDData.length > 0
        ? getAssessmentReportByEmpIDData
          .slice(0, 5)
          .map((ele, index) => ({
            id: index + 1,
            label: ele?.dimension ?? "",
            color: ele?.colorCode ?? "",
          }))
        : [];


    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };


    console.log("getCoachUserSurveyListData----->", getCoachUserSurveyListData);




    const actionData = {
      "title": "Your Actions",
      "actionText": "See all",
      "cards": [
        {
          "id": "action-1",
          "iconType": <MdOutlineStarOutline size={32} />,
          "title": "TalentPlus Strengths",
          "status": "Completed",
          "date": "05 January, 2026",
          "description": "Discover your 28 unique talent themes and understand your natural wiring.",
          "btnText": "View Report"
        },
        {
          "id": "action-2",
          "iconType": <HiOutlineBriefcase size={32} />,
          "title": "Career Fit Assessment",
          "status": "In-Progress",
          "date": "05 January, 2026",
          "description": "Align your strengths to roles and industries that bring out your best work.",
          "btnText": "Take Assessment"
        },
        {
          "id": "action-3",
          "iconType": <BsLightningCharge size={32} />,
          "title": "FLOW Profile",
          "status": "Not started",
          "date": "05 January, 2026",
          "description": "Identify your creative and cognitive flow state triggers for peak performance.",
          "btnText": "Take Assessment"
        }
      ]
    };




    return (
      <div className="h-dvh">
        {check === 1 && false ? (
          <>
            {surveyLanguageRTL ?
              <SurveyRTL
                handleGenderChange={this.handleGenderChange}
                handleAgeGroupChange={this.handleAgeGroupChange}

                viewReport={this.viewReport}
                onLogout={onLogout}
                handleLanguage={this.handleLanguage}
                handleNameInput={this.handleNameInput}
                onUpdateDetails={this.onUpdateDetails}
                goToUpdateDetailsPage={this.goToUpdateDetailsPage}
                goToQuestionPage={this.goToQuestionPage}
                ansNPSInput={this.ansNPSInput}
                nextQues={this.nextQues}
                onMandatoryAttempt={this.onMandatoryAttempt}
                saveAnswers={this.saveAnswers}

                getSecondsToTimeReverse={getSecondsToTimeReverse}
                isSchool={isSchool}
                surveyLanguageRTL={surveyLanguageRTL}
                showNameEditScreen={showNameEditScreen}
                nameFormData={nameFormData}
                errNameForm={errNameForm}
                surveyScreenData={surveyScreenData}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                surveyLanguageName={surveyLanguageName}
                LanguageList={LanguageList}
                surveyStatus={surveyStatus}
                showWelcomeScreen={showWelcomeScreen}

                questionsList={questionsList}
                themeType={themeType}
                getTheme={getTheme}
                SurveyAttributes={SurveyAttributes}
                surveyLanguageCode={surveyLanguageCode}
                functionNameVariable={functionNameVariable}
                welcomeTextDislay={welcomeTextDislay}
                instructionPage={instructionPage}
                LabelObj={LabelObj}
                instructionTextDislay={instructionTextDislay}
                afterSubmitData={afterSubmitData}
                showQuestionScreen={showQuestionScreen}
                submitSucces={submitSucces}

                getSecondsToTime={getSecondsToTime}
                CurrQuesIndex={CurrQuesIndex}
                answersList={answersList}
                isMobile={isMobile}
                unattemptList={unattemptList}
                showRedFlag={showRedFlag}
                ShowSubmitButton={ShowSubmitButton}
                submitMandatory={submitMandatory}
                showThankyouScreen={showThankyouScreen}
                showViewReportThankYouButton={showViewReportThankYouButton}
                downloadStatusNo={downloadStatusNo}


                alreadySubmitted={alreadySubmitted}
                bgType={bgType}
                bgColor={bgColor}
                timeCounter={timeCounter}
                getGroupIndex={getGroupIndex}
                hexToRgbA={hexToRgbA}
                bgImage={bgImage}

              />
              :
              <Survey
                handleGenderChange={this.handleGenderChange}
                handleAgeGroupChange={this.handleAgeGroupChange}
                viewReport={this.viewReport}
                onLogout={onLogout}
                handleLanguage={this.handleLanguage}
                handleNameInput={this.handleNameInput}
                onUpdateDetails={this.onUpdateDetails}
                goToUpdateDetailsPage={this.goToUpdateDetailsPage}
                goToQuestionPage={this.goToQuestionPage}
                ansNPSInput={this.ansNPSInput}
                nextQues={this.nextQues}
                onMandatoryAttempt={this.onMandatoryAttempt}
                saveAnswers={this.saveAnswers}

                getSecondsToTimeReverse={getSecondsToTimeReverse}
                isSchool={isSchool}
                surveyLanguageRTL={surveyLanguageRTL}
                showNameEditScreen={showNameEditScreen}
                nameFormData={nameFormData}
                errNameForm={errNameForm}
                surveyScreenData={surveyScreenData}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                surveyLanguageName={surveyLanguageName}
                LanguageList={LanguageList}
                surveyStatus={surveyStatus}
                showWelcomeScreen={showWelcomeScreen}

                questionsList={questionsList}
                themeType={themeType}
                getTheme={getTheme}
                SurveyAttributes={SurveyAttributes}
                surveyLanguageCode={surveyLanguageCode}
                functionNameVariable={functionNameVariable}
                welcomeTextDislay={welcomeTextDislay}
                instructionPage={instructionPage}
                LabelObj={LabelObj}
                instructionTextDislay={instructionTextDislay}
                afterSubmitData={afterSubmitData}
                showQuestionScreen={showQuestionScreen}
                submitSucces={submitSucces}

                getSecondsToTime={getSecondsToTime}
                CurrQuesIndex={CurrQuesIndex}
                answersList={answersList}
                isMobile={isMobile}
                unattemptList={unattemptList}
                showRedFlag={showRedFlag}
                ShowSubmitButton={ShowSubmitButton}
                submitMandatory={submitMandatory}
                showThankyouScreen={showThankyouScreen}
                showViewReportThankYouButton={showViewReportThankYouButton}
                downloadStatusNo={downloadStatusNo}


                alreadySubmitted={alreadySubmitted}
                bgType={bgType}
                bgColor={bgColor}
                timeCounter={timeCounter}
                getGroupIndex={getGroupIndex}
                hexToRgbA={hexToRgbA}
                bgImage={bgImage}

              />
            }
          </>
        ) : null}


        {check === 2 || true ? (
          <>
            <DashboardUser showBot={true} openAIBot={openAIBot} userDetails={userDetails} onLogout={onLogout} switchToAdmin={switchToAdmin}>

              <div className="min-h-screen overflow-hidden overflow-y-auto">
                {false &&
                  <div className="mb-10">
                    <div className="flex justify-between items-center mb-2">
                      <Heading className="text-2xl" title="Executive Snippet" />
                      <ViewButton onClick={() => onAssessmentSummary(1)} title="View All" Icon={MdArrowForwardIos} />
                    </div>
                    {/* Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      {assessments && assessments.length > 0 &&
                        <div className="bg-white border rounded-xl p-6">
                          <Heading className="text-xl" title="Your Talent Snapshot" />
                          <p className="text-sm textlight my-2">Based on your most recent assessment, your top 5 talent themes.</p>
                          <p className="text-xs font-medium italic textblack mb-6">Last assessed: Apr 15, 2024</p>
                          <div className="grid grid-cols-2 gap-6 items-center">
                            <TriangleChart colors={assessments.map((ele) => (ele.color))} />
                            <div className="space-y-2 text-sm">
                              {assessments.map((ele) => (
                                <p key={ele.id} className="flex items-center">
                                  <span style={{ borderColor: hexToRgbA(ele.color, "100") }}
                                    className="inline-block h-10 border-l-2 px-1">
                                  </span>
                                  <span className="font-medium textblack">{ele.id + ". " + ele.label}</span>
                                </p>
                              ))}
                            </div>
                          </div>
                        </div>}
                    </div>
                    <style jsx>{`.clip-pyramid {  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);}`}</style>
                  </div>}



                {/* Your Action */}
                <div className="flex justify-between items-center mb-2">
                  <Heading className="text-2xl" title={actionData.title} />
                  <button className="textcolor hover:text-blue-600 hove:underline text-xl flex items-center space-x-1 transition cursor-pointer">
                    <span>{actionData.actionText}</span>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>

                {/* 2. Map loop iterating through the rendered JSON content items */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mb-10">
                  {actionData.cards.map((card) => (
                    <div key={card.id} className="bg-white border rounded-lg p-6 flex flex-col justify-between shadow-[0_4px_25px_rgba(0,0,0,0.02)] hover:shadow-md transition duration-200 text-left">
                      <div>
                        <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center textcolor mb-4">{card.iconType}</div>
                        <div className="flex items-center flex-wrap gap-2 mb-2">
                          <Heading className="text-xl" title={card.title} />
                          <span className={`text-sm font-semibold px-2.5 py-0.5 rounded-full border ${this.getBadgeStyle(card.status)}`}>{card.status}</span>
                        </div>
                        <p className="text-sm textlight mb-3 leading-relaxed">{card.description}</p>
                        <p className="text-sm italic textlight mt-3 mb-6 leading-relaxed">{card.date}</p>
                      </div>

                      {/* Action Trigger Button */}
                      <button className="w-full border border-[#09529b] textcolor px-4 py-3 rounded-md flex items-center justify-center space-x-2 transition duration-150 group">
                        <span>{card.btnText}</span>
                        <svg className="w-4 h-4 transform group-hover:translate-x-0.5 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>


                {/* Assessment Section */}
                {assessments && assessments.length > 0 &&
                  <div className="mb-10">
                    <div className="flex justify-between items-center mb-2">
                      <Heading className="text-2xl" title="Talent Insight" />
                    </div>
                    <div className="grid lg:grid-cols-3 grid-cols-1 gap-6">
                      {/* Summary Card */}
                      <div className="bg-white border rounded-lg p-6">
                        <ul className="space-y-2 mb-4">
                          {assessments.map((ele) => (
                            <li key={ele.id} className="flex items-center gap-3 px-3 py-3 rounded" style={{ background: hexToRgbA(ele.color, "0.20") }}>
                              <span style={{ background: hexToRgbA(ele.color, "0.70") }} className="w-6 h-6 rounded-full text-white text-xs flex items-center justify-center font-bold">{ele.id}</span>
                              <span className="text-sm font-medium">{ele.label}</span>
                            </li>
                          ))}
                        </ul>
                        <Heading className="text-xl" title="Summary" />
                        <p className="text-sm textlight my-3">Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                        <button onClick={() => onAssessmentSummary(1)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">
                          View Summary
                        </button>
                      </div>

                      {/* Report Card */}
                      <div className="bg-white border rounded-lg p-6">
                        <img src="/img/dashboardhr/report.png" alt="report" className="rounded-md mb-4 w-full" />
                        <Heading className="text-xl" title="Report" />
                        <p className="text-sm textlight my-3"> Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                        <button onClick={() => onAssessmentSummary(2)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">View Report</button>
                      </div>

                      {/* Video Card */}
                      <div className="bg-white border rounded-lg p-6">
                        <div className="relative mb-4">
                          <img src="/img/dashboardhr/video.png" alt="video" className="rounded-md w-full" />
                          <span className="absolute inset-0 flex items-center justify-center text-white text-3xl">
                            ▶
                          </span>
                        </div>
                        <Heading className="text-xl" title="Assessment Video" />
                        <p className="text-sm textlight my-3"> Your Dominant themes are the core qualities that define who you are and contribute to your success.</p>
                        <button onClick={() => onAssessmentSummary(3)} className="border border-[#09529b] textcolor px-4 py-2 rounded-md">Watch Video</button>
                      </div>
                    </div>
                  </div>}

              </div>

            </DashboardUser>
          </>
        ) : null}



        {false ? (
          <div
            className="w-full h-screen overflow-y-auto bg-[#FAFAFA]"  >
            <div className="z-20 bg-white">
              <LogoAssessmentSummaryHeader
                logout={onLogout}
                surveyScreenData={surveyScreenData}
                template={"v4"}
                details={getAssessmenrEmployeeDetailsData}
                handleReport={this.viewReport}
                surveyLanguageName={surveyLanguageName}
                handleLanguage={this.handleLanguage}
                LanguageList={LanguageList}

                crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
              />

              <div className="sticky bottom-0 z-20 w-full px-4 mx-auto xl:w-11/12 xl:px-0">
                <div className="flex justify-between overflow-x-auto text-sm md:justify-start md:space-x-8 whitespace-nowrap lg:text-base">
                  <button onClick={() => this.handleMainMenu("Summary")} className={showMainMenu === "Summary" ? "flex md:flex-row flex-col gap-2 items-center   md:py-4 py-2 border-b-[3px] border-[#2196F3] text-[#212121" : "flex md:flex-row flex-col gap-2 items-center  md:py-4 py-2 border-b-[3px] border-transparent text-[#212121] opacity-90"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 40" fill="none">
                      <g clipPath="url(#clip0_4081_272)">
                        <path d="M35.556 6.66667H4.44488C3.85551 6.66667 3.29028 6.9008 2.87353 7.31755C2.45678 7.73429 2.22266 8.29952 2.22266 8.88889V31.1111C2.22266 31.7005 2.45678 32.2657 2.87353 32.6825C3.29028 33.0992 3.85551 33.3333 4.44488 33.3333H35.556C36.1454 33.3333 36.7106 33.0992 37.1273 32.6825C37.5441 32.2657 37.7782 31.7005 37.7782 31.1111V8.88889C37.7782 8.29952 37.5441 7.73429 37.1273 7.31755C36.7106 6.9008 36.1454 6.66667 35.556 6.66667ZM35.556 31.1111H4.44488V8.88889H35.556V31.1111Z" fill="#212121" />
                        <path d="M9.99978 15.5556H29.9998C30.2945 15.5556 30.5771 15.4385 30.7855 15.2301C30.9938 15.0217 31.1109 14.7391 31.1109 14.4444C31.1109 14.1498 30.9938 13.8671 30.7855 13.6588C30.5771 13.4504 30.2945 13.3333 29.9998 13.3333H9.99978C9.7051 13.3333 9.42248 13.4504 9.21411 13.6588C9.00574 13.8671 8.88867 14.1498 8.88867 14.4444C8.88867 14.7391 9.00574 15.0217 9.21411 15.2301C9.42248 15.4385 9.7051 15.5556 9.99978 15.5556Z" fill="#212121" />
                        <path d="M9.99978 20H29.9998C30.2945 20 30.5771 19.8829 30.7855 19.6746C30.9938 19.4662 31.1109 19.1836 31.1109 18.8889C31.1109 18.5942 30.9938 18.3116 30.7855 18.1032C30.5771 17.8948 30.2945 17.7778 29.9998 17.7778H9.99978C9.7051 17.7778 9.42248 17.8948 9.21411 18.1032C9.00574 18.3116 8.88867 18.5942 8.88867 18.8889C8.88867 19.1836 9.00574 19.4662 9.21411 19.6746C9.42248 19.8829 9.7051 20 9.99978 20Z" fill="#212121" />
                        <path d="M9.99978 24.4445H21.1109C21.4056 24.4445 21.6882 24.3274 21.8966 24.119C22.1049 23.9106 22.222 23.628 22.222 23.3333C22.222 23.0387 22.1049 22.756 21.8966 22.5477C21.6882 22.3393 21.4056 22.2222 21.1109 22.2222H9.99978C9.7051 22.2222 9.42248 22.3393 9.21411 22.5477C9.00574 22.756 8.88867 23.0387 8.88867 23.3333C8.88867 23.628 9.00574 23.9106 9.21411 24.119C9.42248 24.3274 9.7051 24.4445 9.99978 24.4445Z" fill="#212121" />
                      </g>
                      <defs>
                        <clipPath id="clip0_4081_272">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>Summary</span>
                  </button>

                  {/* <button onClick={() => this.handleMainMenu("Top5Summary")} className={showMainMenu === "Top5Summary" ? "flex md:flex-row flex-col gap-2 items-center   md:py-4 py-2 border-b-[3px] border-[#2196F3] text-[#212121" : "flex md:flex-row flex-col gap-2 items-center  md:py-4 py-2 border-b-[3px] border-transparent text-[#212121] opacity-90"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 40" fill="none">
                      <path d="M5 35V31.6667C5 29.8986 5.70238 28.2029 6.95262 26.9526C8.20286 25.7024 9.89856 25 11.6667 25H18.3333C20.1014 25 21.7971 25.7024 23.0474 26.9526C24.2976 28.2029 25 29.8986 25 31.6667V35M26.6667 5.21667C28.1007 5.58384 29.3717 6.41784 30.2794 7.58718C31.1871 8.75653 31.6797 10.1947 31.6797 11.675C31.6797 13.1553 31.1871 14.5935 30.2794 15.7628C29.3717 16.9322 28.1007 17.7662 26.6667 18.1333M35 35V31.6667C34.9915 30.1953 34.4965 28.768 33.5921 27.6073C32.6877 26.4467 31.4247 25.6178 30 25.25M8.33333 11.6667C8.33333 13.4348 9.03571 15.1305 10.286 16.3807C11.5362 17.631 13.2319 18.3333 15 18.3333C16.7681 18.3333 18.4638 17.631 19.714 16.3807C20.9643 15.1305 21.6667 13.4348 21.6667 11.6667C21.6667 9.89856 20.9643 8.20286 19.714 6.95262C18.4638 5.70238 16.7681 5 15 5C13.2319 5 11.5362 5.70238 10.286 6.95262C9.03571 8.20286 8.33333 9.89856 8.33333 11.6667Z" stroke="#212121" stroke-opacity="0.7" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Top 5 Insight</span>
                  </button> */}

                  <button onClick={() => this.handleMainMenu("Report")} className={showMainMenu === "Report" ? "flex md:flex-row flex-col gap-2 items-center   md:py-4 py-2 border-b-[3px] border-[#2196F3] text-[#212121" : "flex md:flex-row flex-col gap-2 items-center  md:py-4 py-2 border-b-[3px] border-transparent text-[#212121] opacity-90"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 40" fill="none">
                      <path d="M5 35V31.6667C5 29.8986 5.70238 28.2029 6.95262 26.9526C8.20286 25.7024 9.89856 25 11.6667 25H18.3333C20.1014 25 21.7971 25.7024 23.0474 26.9526C24.2976 28.2029 25 29.8986 25 31.6667V35M26.6667 5.21667C28.1007 5.58384 29.3717 6.41784 30.2794 7.58718C31.1871 8.75653 31.6797 10.1947 31.6797 11.675C31.6797 13.1553 31.1871 14.5935 30.2794 15.7628C29.3717 16.9322 28.1007 17.7662 26.6667 18.1333M35 35V31.6667C34.9915 30.1953 34.4965 28.768 33.5921 27.6073C32.6877 26.4467 31.4247 25.6178 30 25.25M8.33333 11.6667C8.33333 13.4348 9.03571 15.1305 10.286 16.3807C11.5362 17.631 13.2319 18.3333 15 18.3333C16.7681 18.3333 18.4638 17.631 19.714 16.3807C20.9643 15.1305 21.6667 13.4348 21.6667 11.6667C21.6667 9.89856 20.9643 8.20286 19.714 6.95262C18.4638 5.70238 16.7681 5 15 5C13.2319 5 11.5362 5.70238 10.286 6.95262C9.03571 8.20286 8.33333 9.89856 8.33333 11.6667Z" stroke="#212121" stroke-opacity="0.7" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Report</span>
                  </button>

                  {
                    !isSchool ?
                      <>
                        <button onClick={() => this.handleMainMenu("VideoTutorials")} className={showMainMenu === "VideoTutorials" ? "flex md:flex-row flex-col gap-2 items-center   md:py-4 py-2 border-b-[3px] border-[#2196F3] text-[#212121" : "flex md:flex-row flex-col gap-2 items-center  md:py-4 py-2 border-b-[3px] border-transparent text-[#212121] opacity-90"}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 40" fill="none">
                            <path d="M25 16.6667L32.5883 12.8733C32.8424 12.7464 33.1246 12.6865 33.4083 12.6992C33.692 12.712 33.9677 12.7971 34.2093 12.9463C34.4509 13.0956 34.6504 13.3041 34.7888 13.5521C34.9271 13.8001 34.9998 14.0793 35 14.3633V25.6367C34.9998 25.9207 34.9271 26.1999 34.7888 26.4479C34.6504 26.6959 34.4509 26.9044 34.2093 27.0537C33.9677 27.2029 33.692 27.288 33.4083 27.3008C33.1246 27.3135 32.8424 27.2536 32.5883 27.1267L25 23.3333V16.6667ZM5 13.3333C5 12.4493 5.35119 11.6014 5.97631 10.9763C6.60143 10.3512 7.44928 10 8.33333 10H21.6667C22.5507 10 23.3986 10.3512 24.0237 10.9763C24.6488 11.6014 25 12.4493 25 13.3333V26.6667C25 27.5507 24.6488 28.3986 24.0237 29.0237C23.3986 29.6488 22.5507 30 21.6667 30H8.33333C7.44928 30 6.60143 29.6488 5.97631 29.0237C5.35119 28.3986 5 27.5507 5 26.6667V13.3333Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span>Video Tutorials</span>
                        </button>
                        {/* <button onClick={() => this.handleMainMenu("Experts")} className={showMainMenu === "Experts" ? "flex md:flex-row flex-col gap-2 items-center   md:py-4 py-2 border-b-[3px] border-[#2196F3] text-[#212121" : "flex md:flex-row flex-col gap-2 items-center  md:py-4 py-2 border-b-[3px] border-transparent text-[#212121] opacity-90"}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 40 40" fill="none">
                            <path d="M12.5 22.5H22.5V25H12.5V22.5ZM12.5 16.25H27.5V18.75H12.5V16.25ZM12.5 28.75H18.75V31.25H12.5V28.75Z" fill="#212121" fill-opacity="0.7" />
                            <path d="M31.25 6.25H27.5V5C27.5 4.33696 27.2366 3.70107 26.7678 3.23223C26.2989 2.76339 25.663 2.5 25 2.5H15C14.337 2.5 13.7011 2.76339 13.2322 3.23223C12.7634 3.70107 12.5 4.33696 12.5 5V6.25H8.75C8.08696 6.25 7.45107 6.51339 6.98223 6.98223C6.51339 7.45107 6.25 8.08696 6.25 8.75V35C6.25 35.663 6.51339 36.2989 6.98223 36.7678C7.45107 37.2366 8.08696 37.5 8.75 37.5H31.25C31.913 37.5 32.5489 37.2366 33.0178 36.7678C33.4866 36.2989 33.75 35.663 33.75 35V8.75C33.75 8.08696 33.4866 7.45107 33.0178 6.98223C32.5489 6.51339 31.913 6.25 31.25 6.25ZM15 5H25V10H15V5ZM31.25 35H8.75V8.75H12.5V12.5H27.5V8.75H31.25V35Z" fill="#212121" fill-opacity="0.7" />
                          </svg>
                          <span>Experts</span>
                        </button>  */}

                      </> : null
                  }
                </div>
              </div>

            </div>

            {(showMainMenu === "Summary") && (<>
              {surveyLanguageRTL ?
                <SummaryRTL
                  handleReport={this.viewReport}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleSummaryReport={this.handleSummaryReport}
                  getTheme={getTheme}
                  backSummary={this.state.backSummary}
                  showMyExpertList={this.state.showMyExpertList}
                  showMainSummaryModal={this.state.showMainSummaryModal}
                  contactExpertSection={this.state.contactExpertSection}
                  topFiveTalent={this.state.topFiveTalent}
                  handleViewReport={this.handleViewReport}
                  closeReportummaryModal={this.closeReportummaryModal}
                  top5Talent={this.state.top5Talent}
                  handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                  handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                  handleExpertContactModalBack={this.handleExpertContactModalBack}
                  handleExpertContactModal={this.handleExpertContactModal}
                  crrDetail={this.state.crrDetail}
                  crrCodeUserDetails={this.state.crrCodeUserDetails}
                  handleInputExpertForm={this.handleInputExpertForm}
                  errorsCrrCodeUserDetails={this.state.errorsCrrCodeUserDetails}
                  bookExpert={this.bookExpert}
                  userAssessmentExpertOrderPlaceData={userAssessmentExpertOrderPlaceData}
                  handleTestPayment={handleTestPayment}
                  viewMyExpert={this.viewMyExpert}
                  getExpertOrderBookListData={getExpertOrderBookListData}
                  getTalentResourcesData={getTalentResourcesData}
                  handlePlayVideo={this.handlePlayVideo}
                  viewMyVideoReport={this.viewMyVideoReport}
                  isSchool={isSchool}
                  surveyLanguageRTL={surveyLanguageRTL}
                />
                : <Summary
                  handleReport={this.viewReport}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleSummaryReport={this.handleSummaryReport}
                  getTheme={getTheme}
                  backSummary={this.state.backSummary}
                  showMyExpertList={this.state.showMyExpertList}
                  showMainSummaryModal={this.state.showMainSummaryModal}
                  contactExpertSection={this.state.contactExpertSection}
                  topFiveTalent={this.state.topFiveTalent}
                  handleViewReport={this.handleViewReport}
                  closeReportummaryModal={this.closeReportummaryModal}
                  top5Talent={this.state.top5Talent}
                  handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                  handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                  handleExpertContactModalBack={this.handleExpertContactModalBack}
                  handleExpertContactModal={this.handleExpertContactModal}
                  crrDetail={this.state.crrDetail}
                  crrCodeUserDetails={this.state.crrCodeUserDetails}
                  handleInputExpertForm={this.handleInputExpertForm}
                  errorsCrrCodeUserDetails={this.state.errorsCrrCodeUserDetails}
                  bookExpert={this.bookExpert}
                  userAssessmentExpertOrderPlaceData={userAssessmentExpertOrderPlaceData}
                  handleTestPayment={handleTestPayment}
                  viewMyExpert={this.viewMyExpert}
                  getExpertOrderBookListData={getExpertOrderBookListData}
                  getTalentResourcesData={getTalentResourcesData}
                  handlePlayVideo={this.handlePlayVideo}
                  viewMyVideoReport={this.viewMyVideoReport}
                  isSchool={isSchool}
                  surveyLanguageRTL={surveyLanguageRTL}
                />}

            </>)}

            {showMainMenu === "Report" && (<>


              {showSchoolReportModal && isSchool ?
                <>
                  <AssessmentReportSchool
                    closeReportModal={this.closeReportModal}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    onAssessmentByEmpID={this.onAssessmentByEmpID}
                    getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                    createdAt={createdAt}
                    EditButtonFn={EditButtonFn}
                    EditDetailsFn={EditDetailsFn}
                    handleDownloadStatus={this.handleDownloadStatus}
                    loading={loading}
                    isUser={true}
                    surveyLanguageRTL={surveyLanguageRTL}
                  />
                </>
                : null}


              {showReportModal ? (
                <AssessmentReport
                  closeReportModal={this.closeReportModal}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  onAssessmentByEmpID={this.onAssessmentByEmpID}
                  getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleDownloadStatus={this.handleDownloadStatus}
                  loading={loading}
                  isUser={true}
                  surveyLanguageRTL={surveyLanguageRTL}
                  surveyLanguageCode={surveyLanguageCode}
                  surveyLanguageName={surveyLanguageName}
                  downloadRTLReport={this.downloadRTLReport}
                  sendPDFMail={this.sendPDFMail}

                />
              ) : null}

              {showSummaryReport ? (
                <AssessmentSummary
                  closeReportModal={this.closeSummaryReportModal}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  onAssessmentByEmpID={this.onAssessmentByEmpID}
                  getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleDownloadStatus={this.handleDownloadStatus}
                  loading={loading}
                  isUser={true}
                  surveyLanguageRTL={surveyLanguageRTL}
                />
              ) : null}

              {showManagerReportModal ? (
                <AssessmentManagerReport
                  closeReportModal={this.closeManagerReportModal}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  getAssessmenrEmployeeDetailsData={crrEmpDetails}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleDownloadStatus={this.handleDownloadStatus}
                  loading={loading}
                  isUser={true}
                  surveyLanguageRTL={surveyLanguageRTL}
                />
              ) : null}

              {showHiringReportModal ? (
                <AssessmentHiringReport
                  closeReportModal={this.closeHiringReportModal}
                  getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                  getAssessmenrEmployeeDetailsData={crrEmpDetails}
                  createdAt={createdAt}
                  EditButtonFn={EditButtonFn}
                  EditDetailsFn={EditDetailsFn}
                  handleDownloadStatus={this.handleDownloadStatus}
                  loading={loading}
                  isUser={true}
                  surveyLanguageRTL={surveyLanguageRTL}
                />
              ) : null}

            </>)}

            {showMainMenu === "Top5Summary" && (<>

              <AssessmentTop5Summary
                closeReportModal={this.closeReportModal}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                onAssessmentByEmpID={this.onAssessmentByEmpID}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleDownloadStatus={this.handleDownloadStatus}
                loading={loading}
                isUser={true}
                surveyLanguageRTL={surveyLanguageRTL}
                surveyLanguageCode={surveyLanguageCode}
                downloadRTLReport={this.downloadRTLReport}
              />


            </>)}

            {showMainMenu === "VideoTutorials" && (<>
              <VideoCourse
                getTalentResourcesData={getTalentResourcesData}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                getTheme={getTheme}
                closeVideoCourse={this.closeVideoCourse}
                showReportModal={showReportModal}
                showSummaryReport={showSummaryReport}
                surveyLanguageRTL={surveyLanguageRTL}
              />
            </>)}

            {(showMainMenu === "Experts") && (<>
              <ExpertScreen
                handleReport={this.viewReport}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleSummaryReport={this.handleSummaryReport}
                getTheme={getTheme}
                backSummary={this.state.backSummary}
                showMyExpertList={this.state.showMyExpertList}
                showMainSummaryModal={this.state.showMainSummaryModal}
                contactExpertSection={this.state.contactExpertSection}
                topFiveTalent={this.state.topFiveTalent}
                handleViewReport={this.handleViewReport}
                closeReportummaryModal={this.closeReportummaryModal}
                handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                handleExpertContactModalBack={this.handleExpertContactModalBack}
                handleExpertContactModal={this.handleExpertContactModal}
                crrDetail={this.state.crrDetail}
                crrCodeUserDetails={this.state.crrCodeUserDetails}
                handleInputExpertForm={this.handleInputExpertForm}
                errorsCrrCodeUserDetails={this.state.errorsCrrCodeUserDetails}
                bookExpert={this.bookExpert}
                userAssessmentExpertOrderPlaceData={userAssessmentExpertOrderPlaceData}
                handleTestPayment={handleTestPayment}
                viewMyExpert={this.viewMyExpert}
                getExpertOrderBookListData={getExpertOrderBookListData}
                getTalentResourcesData={getTalentResourcesData}
                handlePlayVideo={this.handlePlayVideo}
                viewMyVideoReport={this.viewMyVideoReport}
                surveyLanguageRTL={surveyLanguageRTL}
              />
            </>)}

            {/* {showVideoResource ?
                <>
                  <VideoCourse
                    getTalentResourcesData={getTalentResourcesData}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}

                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    EditButtonFn={EditButtonFn}
                    EditDetailsFn={EditDetailsFn}
                    getTheme={getTheme}

                    closeVideoCourse={this.closeVideoCourse}

                  />
                </>
                :
                <>
                  <Summary
                    handleReport={this.viewReport}
                    getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                    crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                    createdAt={createdAt}
                    EditButtonFn={EditButtonFn}
                    EditDetailsFn={EditDetailsFn}
                    handleSummaryReport={this.handleSummaryReport}
                    getTheme={getTheme}


                    backSummary={this.state.backSummary}
                    showMyExpertList={this.state.showMyExpertList}
                    showMainSummaryModal={this.state.showMainSummaryModal}
                    contactExpertSection={this.state.contactExpertSection}
                    topFiveTalent={this.state.topFiveTalent}
                    handleViewReport={this.handleViewReport}
                    closeReportummaryModal={this.closeReportummaryModal}


                    handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                    handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                    handleExpertContactModalBack={this.handleExpertContactModalBack}
                    handleExpertContactModal={this.handleExpertContactModal}

                    crrDetail={this.state.crrDetail}
                    crrCodeUserDetails={this.state.crrCodeUserDetails}

                    handleInputExpertForm={this.handleInputExpertForm}
                    errorsCrrCodeUserDetails={this.state.errorsCrrCodeUserDetails}

                    bookExpert={this.bookExpert}

                    userAssessmentExpertOrderPlaceData={userAssessmentExpertOrderPlaceData}
                    handleTestPayment={handleTestPayment}
                    viewMyExpert={this.viewMyExpert}

                    getExpertOrderBookListData={getExpertOrderBookListData}

                    getTalentResourcesData={getTalentResourcesData}

                    handlePlayVideo={this.handlePlayVideo}

                    viewMyVideoReport={this.viewMyVideoReport}
                  />
                </>
              } */}
          </div>
        ) : null}


        {showVideoModal ? (
          <VideoFrameModal
            getTalentResourcesData={getTalentResourcesData}
            dimension={showVideoModal}
            closeVideoModal={this.closeVideoModal}
          />
        ) : null}



      </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    assessment
  };
}

export default connect(mapStateToProps)(QuestionPublish);